export default __webpack_public_path__ + "static/reel-placeholder-2e7dbf919ca6854f3602a90e7d31614d.mp4";